import { Const } from "@/const";

export class CloudAccount{
    private _isSignIn : boolean = false;
    public get isSignIn(){ return this._isSignIn; }
    public set isSignIn(_isSignIn : boolean){ this._isSignIn = _isSignIn; }

    public signOutTimeCount : number = 15;
    public updateRefreshTokenTimCount : number = 15;

    // signOut: 1, 自動signOut: 2, 自動signOut後ユーザーに知らせた後:3
    public signOutType = 0;

    public toGo : string = "";

    constructor(){
        this.isSignIn = false;
        this.signOutType = 0;
        this.signOutTimeCount = Const.LABELYASAN_CLOUD_SIGN_OUT_TIME;
        this.updateRefreshTokenTimCount = Const.LABELYASAN_CLOUD_UPDATE_REFRESH_TOKEN_TIME;
    }
}
